import React from "react";

function PackageBooking() {
  return <div>PackageBooking</div>;
}

export default PackageBooking;
